import { Theme } from "@emotion/react";
import React from "react";
import { styled } from "@iventis/styles";

export const DragAndDropItemPlacement = ({ insideGroup, dataTestId }: { insideGroup: boolean; dataTestId?: string }) => (
    <LayerPlacementContainer data-testid={dataTestId} insideGroup={insideGroup}>
        <div className="bar" />
    </LayerPlacementContainer>
);

const LayerPlacementContainer = styled.div<{ insideGroup: boolean }>`
    position: absolute;
    top: 0px;
    height: 2px;
    width: 100%;
    display: flex;
    justify-content: ${({ insideGroup }) => (insideGroup ? "flex-end" : "center")};
    .bar {
        width: ${({ insideGroup }) => (insideGroup ? "85%" : "95%")};
        background-color: ${({ theme }: { theme: Theme }) => theme.tertiaryColors.primary};
    }
`;
